/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./EmailVerification.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

class EmailVerification extends Component {
  render() {
    const languageObj = this.props.languageObj;

    //  const color = this.props.location.state.color;

    const backgroundOverrideStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };

    const backgroundbuttonOverrideStyle = {
      background: "#" + this.props.location.state.color.buttonColor,
    };

    const textOverrideStyle = {
      color: "#" + this.props.location.state.color.buttonColor,
    };
    /*
    const buttonOverrideStyle = {
      background: '#' + this.props.location.state.color.headerColor,
      color: '#' + this.props.location.state.color.buttonColor
    };
*/
    const buttonInverseOverrideStyle = {
      color: "#" + this.props.location.state.color.headerColor,
      background: "#" + this.props.location.state.color.buttonColor,
    };

    return (
      <div className="EmailVerification-view">
        <div
          className="EmailVerification-prompt"
          style={backgroundOverrideStyle}
        >
          <div className="EmailVerification-heading">
            Please verify your email address by following the steps below.
          </div>
          <div className="EmailVerification-mailboxContainer">
            <div
              className="EmailVerification-mailboxIcn"
              style={backgroundbuttonOverrideStyle}
            ></div>
            <div className="EmailVerification-text" style={textOverrideStyle}>
              CheckPlus has sent you an email with a verification link.
            </div>
          </div>

          <div className="EmailVerification-mailboxContainer">
            <div
              className="EmailVerification-verificationBtn"
              style={backgroundbuttonOverrideStyle}
            ></div>
            <div className="EmailVerification-text" style={textOverrideStyle}>
              Verify your email by clicking the verification link.
            </div>
          </div>

          <div className="EmailVerification-divider" style={textOverrideStyle}>
            {languageObj.orText || "OR"}
          </div>

          <div className="EmailVerification-mailboxContainer">
            <div
              className="EmailVerification-codeBtn"
              style={backgroundbuttonOverrideStyle}
            ></div>
            <div className="EmailVerification-text" style={textOverrideStyle}>
              {languageObj.enterCodeText || "Enter the 6-digit verification code from the email"}
            </div>
          </div>

          <Link
            to={{
              pathname: "/VerifyCode",
              state: this.props.location.state,
            }}
          >
            <div
              className="EmailVerification-verifyCodeBtn"
              style={buttonInverseOverrideStyle}
            >
              {languageObj.verifyCodeBtn || "Enter Verification Code"}
            </div>
          </Link>

          <div className="EmailVerification-mailboxContainer">
            <div
              className="EmailVerification-returnBtn"
              style={backgroundbuttonOverrideStyle}
            ></div>
            <div className="EmailVerification-text" style={textOverrideStyle}>
              Return to the nonprofit page to log in
            </div>
          </div>

          <a href="/SelectMission">
            <div
              className="EmailVerification-doneBtn"
              style={buttonInverseOverrideStyle}
            >
              {languageObj.doneBtn}
            </div>
          </a>
        </div>
      </div>
    );
  }
}

EmailVerification.propTypes = {
  language: PropTypes.string,
  languageObj: PropTypes.object,
};

export default EmailVerification;
